// extracted by mini-css-extract-plugin
module.exports = {"ExperienceMenu__item":"lp_a"};